import { SET_CONFIGS } from "../actions/configActions";


const defaultState = {
    configs: []
}

export const configReducer = (state = defaultState, action: any) => {
    const { type, data } = action;
    if (type === SET_CONFIGS) return { ...state, configs: data };
    return state;
}